import { Howl, Howler } from 'howler';

class SoundManager {
    static playNewMessageSound() {
        const sound = new Howl({
            src: ['new-message.mp3'],
            autoplay: true,
            volume: 0.5,
        });
        sound.play();
    }

    static playSentMessageSound() {
        const sound = new Howl({
            src: ['sent-message.mp3'],
            autoplay: true,
            volume: 0.5,
        });
        sound.play();
    }

    static clockTickSound;
    static playClockTickingSound() {
        this.clockTickSound = new Howl({
            src: ['clock-tick.mp3'],
            autoplay: true,
            volume: 0.5,
        });
        this.clockTickSound.play();
    }

    static stopClickTickingSound() {
        if (this.clockTickSound) {
            this.clockTickSound.stop();
        }
    }

    static playAlarmSound() {
        const sound = new Howl({
            src: ['digital-alarm-cut.mp3'],
            autoplay: true,
            volume: 0.5,
        });
        sound.play();
    }

    //TODO stop all sounds method that can be used when player leaves the room
    static stopAllSounds() {
        Howler.stop();
    }

}

export default SoundManager;